
import { defineComponent } from 'vue'
import NameAndProfession from './components/NameAndProfession.vue'
import MyTechnologies from './components/MyTechnologies.vue'
import MySocials from './components/MySocials.vue'
import MySocialsMobile from './components/MySocialsMobile.vue'
import AboutMe from './components/AboutMe.vue'
import ProfessionalExperience from './components/ProfessionalExperience.vue'
import MyProjects from './components/MyProjects.vue'
import DownloadCv from './components/DownloadCv.vue'

export default defineComponent({
  name: 'App',
  components: {
    NameAndProfession,
    MyTechnologies,
    MySocials,
    MySocialsMobile,
    AboutMe,
    ProfessionalExperience,
    MyProjects,
    DownloadCv
  }
})
